import {ActionTree} from "vuex";
import {RootState} from "@service/store/types/RootState";
import {FavoritesState} from "@service/store/types/FavoritesState";
import {isObjectInFavoritesGetter} from "@service/store/favorites/getters";
import {ObjectPair} from "@service/types/ObjectPair";
import {FavoritesObserver} from "@service/store/favorites/FavoritesObserver";
import {repositories} from "@service/api/Repositories";
import {RepositoryFabric} from "@api/repositories/RepositoryFabric";
import { parseJson } from "@common/TypesHelper";

export const fetchFavoritesAction = 'favorites/fetchFavorites';
export const addToFavoriteAction = 'favorites/addToFavorite';
export const removeFromFavoriteAction = 'favorites/removeFromFavorite';
export const updateFavoritesAction = 'favorites/updateFavorites';
export const initObserverAction = 'favorites/initObserver';
export const readAllFavoritesAction = 'favorites/readAll';
export const toggleFavoritesList = 'favorites/toggleList';
export const restoreUnreadedAction = 'favorites/restoreUnreaded';

export const actions: ActionTree<FavoritesState, RootState> = {
    async initObserver({commit}, store) {
        const observer = new FavoritesObserver(repositories.get(RepositoryFabric.REALTIME), store);
        commit('setObserver', observer);
        await observer.connect();
    },
    async fetchFavorites({commit, dispatch, state}, schemaId: string) {
        let favorites: string[] = [];

        try {
            favorites = await state.repository.list(schemaId) || [];
        }
        catch (e) {
            dispatch('reportException', e, { root: true });
        }

        commit('setList', {...state.list, [schemaId]: favorites});
        dispatch("restoreUnreaded")
    },
    async addToFavorite({dispatch, getters, state, commit}, {schemaId, objectId}: ObjectPair) {
        try {
            await state.repository.add(schemaId, objectId);
            commit('addNewFavorites', {schemaId, objectId});
        }
        catch (e) {
            dispatch('reportException', e, { root: true });
        }
    },
    async removeFromFavorite({dispatch, getters, state, commit}, {schemaId, objectId}: ObjectPair) {
        try {
            await state.repository.delete(schemaId, objectId);
            commit('removeFromFavorites', {schemaId, objectId});
        }
        catch (e) {
            dispatch('reportException', e, { root: true });
        }
    },
    async updateFavorites({dispatch, commit}, data) {
        if (data.isFavorite) {
            commit('addNewFavorites', {schemaId: data.schemaId, objectId: data.objectId});
            commit('setUnreadedItem', data.objectId);
        }
        else {
            commit('removeFromFavorites', {schemaId: data.schemaId, objectId: data.objectId});
            commit('removeUnreadedItem', data.objectId);
        }

        dispatch('setUnreadedToLS');
    },

    readAll({ dispatch, commit }) {
        commit('setUnreaded', []);
        dispatch('setUnreadedToLS');
    },

    setUnreadedToLS({ state, getters }) {
        localStorage.setItem(getters.unreadedLsKey, JSON.stringify(state.unreadedItems));
    },

    restoreUnreaded({ getters, commit }) {
        const unreadedItemsFromLS = parseJson(localStorage.getItem(getters.unreadedLsKey), []) || [];
        commit('setUnreaded', unreadedItemsFromLS);
    },
    toggleList({ state }, isOpened) {
        state.listIsOpened = isOpened;
    }
}
